import React from 'react'

export default function Footer2() {
    return (
        <footer className="footer bg-dark">
            <div className="container">
                <div className="row">
                    <div className="col-sm-6">
                        <p className="copyright font-alt">Designed by <a href="#"> Reza Torkashvand</a></p>
                    </div>
                    <div className="col-sm-6">
                        <div className="footer-social-links"><a href="#"><i className="icon-linkedin" /></a><a href="#"><i className="fa fa-facebook" /></a><a href="#"><i className="fa fa-twitter" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
